export default __webpack_public_path__ + "static/media/agenda2.6d11265b.png";